/*
 This file is part of GNU Taler
 (C) 2022-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import { RouteDefinition } from "@gnu-taler/web-util/browser";
import { VNode, h } from "preact";
import { useBankState } from "../hooks/bank-state.js";
import { WithdrawalOperation } from "./OperationState/index.js";

export function WithdrawalOperationPage({
  operationId,
  onOperationAborted,
  onContinueLater,
  routeClose,
}: {
  operationId: string;
  onOperationAborted: () => void;
  onContinueLater?: () => void;
  routeClose: RouteDefinition;
}): VNode {
  const [bankState, updateBankState] = useBankState();
  return (
    <WithdrawalOperation
      operationId={operationId}
      clearWhenTerminal
      onAbort={() => {
        if (bankState.activeWithdrawal?.operationId === operationId) {
          updateBankState("activeWithdrawal", undefined);
        }
        onOperationAborted();
      }}
      onContinueLater={
        onContinueLater
          ? () => {
              if (bankState.activeWithdrawal?.operationId === operationId) {
                updateBankState("activeWithdrawal", {
                  ...bankState.activeWithdrawal,
                  confirmationDeferred: true,
                });
              }
              onContinueLater();
            }
          : undefined
      }
      routeClose={routeClose}
    />
  );
}
